module.exports = __webpack_public_path__ + "common/icon-linkedin-1613a58e1777d7040e18436ad8611eb2.svg";